module.exports = __webpack_public_path__ + "img/play_b2.0eaa39da.png";